// extracted by mini-css-extract-plugin
export default {"formComponent":"noteDialog__formComponent___FxJSK","textField":"noteDialog__textField___JdmHI"};